let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6oPQN"), load("2YtNo"), load("cWvhX")]).then(() => parcelRequire('8M3ga'));